import React from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import i18n from 'i18next';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch() {
    // Error logging can be added here (e.g. external service)
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            mt: 8,
            px: 2,
          }}
        >
          <Alert
            severity="error"
            sx={{ maxWidth: 480, width: '100%', borderRadius: 3 }}
            action={
              <Button
                color="inherit"
                size="small"
                onClick={() => this.setState({ hasError: false })}
              >
                {i18n.t('common:app.retry', 'Erneut versuchen')}
              </Button>
            }
          >
            <Typography fontWeight={700}>
              {i18n.t('common:app.error', 'Etwas ist schiefgelaufen.')}
            </Typography>
            <Typography variant="body2">
              {i18n.t('common:app.errorDescription', 'Bitte versuche es erneut oder lade die Seite neu.')}
            </Typography>
          </Alert>
        </Box>
      );
    }

    return this.props.children;
  }
}
